import { GuidService } from 'ui-components/services/guid-service';

import { ResidentialIndicator } from '../../../../../../enums/residential-indicator';
import { getCurrentDateTimeAsUtcIso } from '../../../../../../services/datetime-service';

const RECEIVING_WAREHOUSE_NAME = 'Fulfilled by ShipStation';

/**
 * @typedef {import('../../../../../../store/orders/orders-api-types.d.ts').ManualOrderRequest} ManualOrderRequest
 */

/**
 * @typedef {import('../../../asn-types.d.ts').AsnProduct} AsnProduct
 */

/**
 * Creates a single order object from all ASN boxes
 * Combines all items across all boxes (considering boxesPerConfig)
 * @param {Array<AsnProduct>} asnProducts
 * @param {string} asnNumber - The ASN purchase order number
 * @param {object} receivingWarehouse - The warehouse where ASN is being sent to
 * @param {string} storeGuid - The store GUID for the order
 * @returns {ManualOrderRequest} Order object ready for API submission
 */
export const createOrderRequestFromAsn = (asnProducts, asnNumber, receivingWarehouse, storeGuid) => {
  const currentDateTimeUtcIso = getCurrentDateTimeAsUtcIso();

  return {
    orderNumber: asnNumber,
    createGuid: GuidService.newGuid(),
    store: {
      storeGuid,
    },
    orderDateTime: currentDateTimeUtcIso,
    paidDateTime: currentDateTimeUtcIso,
    items: asnProducts.map((product) => ({
      sku: product.sku,
      name: product.name,
      quantity: product.quantity,
      quantityOrdered: product.quantity,
      unitPrice: { value: 0, code: 'USD' },
    })),
    amountSummary: {
      shippingPaid: { value: 0, code: 'USD' },
      taxPaid: { value: 0, code: 'USD' },
      totalPaid: { value: 0, code: 'USD' },
    },
    soldTo: {
      email: '',
      name: '',
      phone: '',
    },
    shipToAddress: {
      name: RECEIVING_WAREHOUSE_NAME,
      line1: receivingWarehouse.line1 || '',
      line2: receivingWarehouse.line2 || '',
      line3: receivingWarehouse.line3 || '',
      city: receivingWarehouse.city || '',
      state: receivingWarehouse.state || '',
      postalCode: receivingWarehouse.postalCode || '',
      countryCode: receivingWarehouse.countryCode || '',
      phone: '',
      residentialIndicator: ResidentialIndicator.Commercial,
    },
  };
};
